<template>
  <div class="un-page">

    <!-- Hero -->
    <div class="un-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-domain</v-icon>
        </v-avatar>
        <div>
          <div class="un-hero__title">Unidades de Negocio</div>
          <div class="un-hero__sub">Gestión de unidades de negocio del sistema</div>
        </div>
      </div>
      <v-btn small dark depressed color="rgba(255,255,255,0.18)" @click="editItem()" v-if="$store.state.CARGO.id!=8">
        <v-icon left small>mdi-plus</v-icon> Agregar
      </v-btn>
    </div>

    <div class="un-body">

      <!-- Toolbar -->
      <v-card outlined class="un-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex align-center" style="gap:10px;">
          <v-chip x-small :color="desserts.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ desserts.length }} unidad{{ desserts.length !== 1 ? 'es' : '' }}
          </v-chip>
          <v-spacer />
          <v-btn icon small @click="getunidades" :loading="loading" color="indigo darken-1">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="un-table-card">
        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          hide-default-footer
          disable-pagination
          dense
          class="un-table"
          no-data-text="Sin unidades registradas."
          loading-text="Cargando..."
        >
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex" style="gap:4px;" v-if="$store.state.CARGO.id!=8">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon small color="indigo darken-1" v-on="on" @click="editItem(item)">
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon small color="red darken-1" v-on="on" @click="deleteItem(item)">
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>

    </div>

    <UnidadesAM ref="unidadesam" v-on:onnewreg="getunidades" />
    <UnidadesDEL ref="unidadesdel" />
  </div>
</template>

<script>
import UnidadesAM from '@/views/unidades/Unidadesam.vue';
import UnidadesDEL from '@/views/unidades/Unidadesdel.vue';
import xaxios from '@/xaxios';

export default {
  components: { UnidadesAM, UnidadesDEL },
  data: () => ({
    headers: [
      { text: 'Nombre',      value: 'nombre',      align: 'start' },
      { text: 'Código',      value: 'codigo',       width: 120 },
      { text: 'Descripción', value: 'descripcion' },
      { text: 'Opciones',    value: 'actions',      width: 100, sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {},
    loading: false,
  }),
  created() {
    this.getunidades();
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$refs.unidadesam.openmodal(item);
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$refs.unidadesdel.openmodal();
    },
    async getunidades() {
      const vue = this;
      const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadnegocio`;
      vue.desserts = [];
      vue.loading = true;
      await xaxios
        .get(url)
        .then(({ data }) => {
          vue.desserts = data;
          vue.loading = false;
        })
        .catch((e) => {
          window.console.log(e);
          vue.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.un-page { min-height: 100vh; background: #f5f7fa; }

.un-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.un-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.un-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.un-body { padding: 20px 24px; }

.un-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.un-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.un-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.un-table >>> tbody tr:hover { background: #f0f4ff !important; }
.un-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>
